module.exports = __webpack_public_path__ + "static/media/lowes.a3da928e.png";